/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_CaptionInputs */

const en_reading_class_caption = /** @type {(inputs: Reading_Class_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captions`)
};

const es_reading_class_caption = /** @type {(inputs: Reading_Class_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendas`)
};

/**
* | output |
* | --- |
* | "Captions" |
*
* @param {Reading_Class_CaptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_caption = /** @type {((inputs?: Reading_Class_CaptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_CaptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_caption(inputs)
	return en_reading_class_caption(inputs)
});